import React from 'react';
import { Card } from './ui/Card';
import { Activity } from 'lucide-react';
interface BehaviorRowProps {
  category: string;
  agentScore: number;
  clientScore: number | 'N/A';
}
function BehaviorRow({
  category,
  agentScore,
  clientScore
}: BehaviorRowProps) {
  return <div className="grid grid-cols-12 gap-4 items-center py-3 border-b border-warmgray last:border-0" data-id="element-14">
      <div className="col-span-4 text-sm font-medium text-gray-800" data-id="element-15">
        {category}
      </div>

      {/* Agent Column */}
      <div className="col-span-4 flex items-center gap-3" data-id="element-16">
        <div className="flex-1 h-1.5 bg-warmgray rounded-full overflow-hidden" data-id="element-17">
          <div className="h-full bg-navy rounded-full" style={{
          width: `${agentScore / 10 * 100}%`
        }} data-id="element-18" />
        </div>
        <span className="w-4 text-right text-sm font-serif text-navy" data-id="element-19">
          {agentScore}
        </span>
      </div>

      {/* Client Column */}
      <div className="col-span-4 flex items-center gap-3" data-id="element-20">
        {clientScore !== 'N/A' ? <>
            <div className="flex-1 h-1.5 bg-warmgray rounded-full overflow-hidden" data-id="element-21">
              <div className="h-full bg-crimson rounded-full" style={{
            width: `${clientScore / 10 * 100}%`
          }} data-id="element-22" />
            </div>
            <span className="w-4 text-right text-sm font-serif text-crimson" data-id="element-23">
              {clientScore}
            </span>
          </> : <span className="text-gray-400 italic text-xs w-full text-right pr-1" data-id="element-24">
            N/A
          </span>}
      </div>
    </div>;
}
export function BehaviorAnalysisCard({
  highlighted
}: {
  highlighted?: boolean;
}) {
  return <Card delay={0.4} highlighted={highlighted} data-id="element-25">
      <h2 className="text-2xl text-navy flex items-center gap-2 mb-6" data-id="element-26">
        <Activity className="text-crimson" size={24} data-id="element-27" />
        Behavior Analysis
      </h2>

      <div className="mt-4" data-id="element-28">
        <div className="grid grid-cols-12 gap-4 items-center pb-2 border-b-2 border-warmgray" data-id="element-29">
          <div className="col-span-4 text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-30">
            Category
          </div>
          <div className="col-span-4 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right pr-6" data-id="element-31">
            Agent
          </div>
          <div className="col-span-4 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right pr-6" data-id="element-32">
            Client
          </div>
        </div>

        <div className="flex flex-col" data-id="element-33">
          <BehaviorRow category="Enthusiasm" agentScore={8} clientScore={7} data-id="element-34" />
          <BehaviorRow category="Hesitation" agentScore={3} clientScore={4} data-id="element-35" />
          <BehaviorRow category="Confidence" agentScore={8} clientScore={8} data-id="element-36" />
          <BehaviorRow category="Persuasion" agentScore={7} clientScore="N/A" data-id="element-37" />
          <BehaviorRow category="Rapport" agentScore={8} clientScore="N/A" data-id="element-38" />
        </div>
      </div>
    </Card>;
}